/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{resolveIncludes as t}from"./sources/resolver.js";const e={shaders:{vertexShader:t("bitBlit/bitBlit.vert"),fragmentShader:t("bitBlit/bitBlit.frag")},attributes:new Map([["a_pos",0],["a_tex",1]])};export{e as bitBlit};
